import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { AuthGuard } from "src/app/guard/guard.component";
import { PageNotFoundComponent } from "src/app/share-modul/components/page-not-found/page-not-found.component";
import { LoginWithPinComponent } from "src/app/waiter-panel/components/login-with-pin/login-with-pin/login-with-pin.component";
import { VenuesComponent } from "src/app/waiter-panel/components/venues/venues/venues.component";
import { WaiterTableComponent } from "src/app/waiter-panel/components/waiter-table/waiter-table.component";
import { WaiterTabviewComponent } from "src/app/waiter-panel/components/waiter-tabview/waiter-tabview.component";
import {DisplayOrderComponent} from "../../waiter-panel/components/display-order/display-order.component";
import {DisplayBillsComponent} from "../../waiter-panel/components/display-bills/display-bills.component";

const routes: Routes = [
    { path: 'waiter', component: VenuesComponent, canActivate: [AuthGuard], data: {isWaitersGeneralRoute: true }},
    { path: 'waiter/:id/pin', component: LoginWithPinComponent, canActivate: [AuthGuard], data: {isWaitersGeneralRoute: true } },
    { path: 'waiter/:id/wtr', component: WaiterTabviewComponent, canActivate: [AuthGuard], data: { isWaiterRoute: true }},
    { path: 'waiter/:id/wtr/:id/table', component: WaiterTableComponent, canActivate: [AuthGuard], data: { isWaiterRoute: true }},
    { path: 'waiter/:venue-id/wtr/:table-id/display-order', component: DisplayOrderComponent, canActivate: [AuthGuard], data: { isWaiterRoute: true }},
    { path: 'waiter/:venue-id/wtr/:table-id/display-bills', component: DisplayBillsComponent, canActivate: [AuthGuard], data: { isWaiterRoute: true }},
    { path: 'page-not-found', component: PageNotFoundComponent, canActivate: [AuthGuard] },
    { path: '', redirectTo: 'page-not-found', pathMatch: 'full' },
    { path: '**', redirectTo: 'page-not-found' }
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})

export class WaiterRoutingModule { }
